<div>
  <canvasjs-chart
    [options]="chartOptions"
    [styles]="{ width: '600px', height: '350px' }"
  />
</div>
